import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useContext, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { createUseStyles, Text, Button, Icon } from 'hoi-poi-ui';
import { useWeb5Context } from "../../lib/Web5Context";
import ConditionsContext from "./ConditionsContext";
import { getEmptyCondition, getGroupConditionString } from "./utils";
import Condition from "./Condition";
import OperatorSwitch from "./OperatorSwitch";
import styles from "./styles/group";
const useStyles = createUseStyles(styles, 'ConditionsGroup');
var _ref2 = /*#__PURE__*/React.createElement(Icon, {
  name: "chevron",
  size: "small"
});
const Group = _ref => {
  let {
    expanded,
    group,
    index,
    onChange,
    onDelete,
    toggleExpanded,
    listMapFields,
    options
  } = _ref;
  const {
    t,
    locale
  } = useWeb5Context();
  const classes = useStyles();
  const {
    isReadOnly
  } = useContext(ConditionsContext);
  const {
    conditions,
    operator
  } = group;
  const onChangeGroup = useCallback((op, cond) => {
    onChange(index, {
      operator: op,
      conditions: cond
    });
  }, [index, onChange]);
  const conditionString = useMemo(() => getGroupConditionString(group, locale, listMapFields), [group, locale, listMapFields]);
  const handleConditionChange = useCallback((condIndex, values) => {
    const newConditions = [...conditions];
    newConditions[condIndex] = _objectSpread(_objectSpread({}, newConditions[condIndex]), values);
    onChangeGroup(operator, newConditions);
  }, [conditions, onChangeGroup, operator]);
  const handleAddCondition = useCallback(() => {
    const newConditions = [...conditions];
    newConditions.push(getEmptyCondition());
    onChangeGroup(operator, newConditions);
  }, [conditions, onChangeGroup, operator]);
  const handleRemoveCondition = useCallback(removeIndex => {
    const newConditions = [...conditions.slice(0, removeIndex), ...conditions.slice(removeIndex + 1)];
    if (newConditions.length === 0) {
      newConditions.push(getEmptyCondition());
    }
    onChangeGroup(operator, newConditions);
  }, [conditions, onChangeGroup, operator]);
  const handleRemoveGroup = useCallback(() => {
    onDelete && onDelete(index);
  }, [index, onDelete]);
  const handleLogicOperatorChange = useCallback(val => {
    onChangeGroup(val, conditions);
  }, [conditions, onChangeGroup]);
  const handleGroupClick = useCallback(() => {
    if (!expanded) {
      toggleExpanded(index);
    }
  }, [expanded, index, toggleExpanded]);
  const groupClassName = classnames(classes.root, {
    [classes.expanded]: expanded,
    [classes.collapsed]: !expanded,
    [classes.addConditionRight]: (conditions === null || conditions === void 0 ? void 0 : conditions.length) <= 1
  });
  return /*#__PURE__*/React.createElement("section", {
    className: groupClassName,
    onClick: handleGroupClick
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement("header", {
    className: classes.header
  }, (conditions === null || conditions === void 0 ? void 0 : conditions.length) > 1 && /*#__PURE__*/React.createElement(OperatorSwitch, {
    value: operator,
    onChange: !isReadOnly ? handleLogicOperatorChange : undefined
  }), !isReadOnly && /*#__PURE__*/React.createElement(Button, {
    onClick: handleAddCondition,
    type: "terciary",
    className: "conditions__conditions-group__add-condition-button"
  }, t('cfm_action_add_condition'))), /*#__PURE__*/React.createElement("main", {
    className: classes.body
  }, conditions.map((cond, i) => {
    var _cond$field;
    return /*#__PURE__*/React.createElement(Condition, {
      key: `condition-${index}-${i}-${cond === null || cond === void 0 ? void 0 : (_cond$field = cond.field) === null || _cond$field === void 0 ? void 0 : _cond$field.value}`,
      condition: cond,
      index: i,
      onChange: handleConditionChange,
      onRemove: handleRemoveCondition,
      options: options
    });
  }))), /*#__PURE__*/React.createElement("footer", {
    className: classes.footer
  }, /*#__PURE__*/React.createElement("div", null, !expanded && _ref2, /*#__PURE__*/React.createElement(Text, {
    className: classes.conditionString
  }, conditionString)), !isReadOnly && onDelete && /*#__PURE__*/React.createElement(Button, {
    onClick: handleRemoveGroup,
    type: "secondary-error"
  }, t('cfm_action_delete'))));
};
process.env.NODE_ENV !== "production" ? Group.propTypes = {
  expanded: PropTypes.bool.isRequired,
  group: PropTypes.shape({
    conditions: PropTypes.array,
    operation: PropTypes.string
  }).isRequired,
  index: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  toggleExpanded: PropTypes.func.isRequired
} : void 0;
export default /*#__PURE__*/memo(Group);